import { db, Timestamp } from '@/firebase.js'
import axios from 'axios'
import { firestoreAction } from 'vuexfire'
import { newId, format } from '@/utils'
import { DateTime } from 'luxon'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  reports(state) {
    return Object.assign({}, ...state.data.map((i) => ({ [i.id]: i })))
  },
  reportsOrdered(state, getters) {
    return [
      ...Object.values(getters['reports']).sort(
        (a, b) => b.date.seconds - a.date.seconds
      )
    ]
  },
  reportsOrderedReverse(state, getters) {
    let arr = [
      ...Object.values(getters['reports']).sort(
        (a, b) => a.date.seconds - b.date.seconds
      )
    ]
    arr.shift()
    return arr
  },
  reportById(state) {
    return (id) => {
      return state.data.find((doc) => doc.id === id)
    }
  },
  isReport(state, getters) {
    return (id) => {
      try {
        return Object.keys(getters.data).some((k) => getters.data[k].id === id)
      } catch {
        return false
      }
    }
  },
  reportByWeekNumber(state) {
    return (weekNumber) => {
      try {
        return state.data.find((i) => i.week == weekNumber)
      } catch {
        return null
      }
    }
  },
  reportCsvByReportId(state, getters, rootState, rootGetters) {
    return (reportId) => {
      let formatCsv = (amount) => format(amount).replace(',', '')

      if (!getters['reports'][reportId])
        throw new Error(
          'Invalid ReportID: ',
          reportId ? reportId : 'No ID Provided'
        )

      let report = getters['reports'][reportId]

      let rows = [
        [
          '',
          `Monday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 7 })
            .toFormat('MM/dd')})`,
          `Tuesday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 6 })
            .toFormat('MM/dd')})`,
          `Wednesday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 5 })
            .toFormat('MM/dd')})`,
          `Thursday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 4 })
            .toFormat('MM/dd')})`,
          `Friday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 3 })
            .toFormat('MM/dd')})`,
          `Saturday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 2 })
            .toFormat('MM/dd')})`,
          `Sunday (${DateTime.fromSeconds(report.date.seconds)
            .setZone('America/New_York')
            .minus({ days: 1 })
            .toFormat('MM/dd')})`,
          '',
          'Total',
          'Percent'
          // 'Per Guest'
        ],
        /*['Guest Count', '', '', '', '', '', '', '', '', '', '', ''],
        [
          'In Store',
          `${report.guests.inStore[0]}`,
          `${report.guests.inStore[1]}`,
          `${report.guests.inStore[2]}`,
          `${report.guests.inStore[3]}`,
          `${report.guests.inStore[4]}`,
          `${report.guests.inStore[5]}`,
          `${report.guests.inStore[6]}`,
          '',
          `${report.guests.inStoreTotal}`,
          `${format(report.guests.inStorePercent, 'percent')}`,
          // '-'
        ],
        [
          'Delivery',
          `${report.guests.delivery[0]}`,
          `${report.guests.delivery[1]}`,
          `${report.guests.delivery[2]}`,
          `${report.guests.delivery[3]}`,
          `${report.guests.delivery[4]}`,
          `${report.guests.delivery[5]}`,
          `${report.guests.delivery[6]}`,
          '',
          `${report.guests.deliveryTotal}`,
          `${format(report.guests.deliveryPercent, 'percent')}`,
          // '-'
        ],
        [
          'Total',
          `${report.guests.totals[0]}`,
          `${report.guests.totals[1]}`,
          `${report.guests.totals[2]}`,
          `${report.guests.totals[3]}`,
          `${report.guests.totals[4]}`,
          `${report.guests.totals[5]}`,
          `${report.guests.totals[6]}`,
          '',
          `${report.guests.total}`,
          '-',
          // '-'
        ],
        ['', '', '', '', '', '', '', '', '', '', '', ''],*/
        ['Sales', '', '', '', '', '', '', '', '', '', ''],
        [
          'In Store',
          `${formatCsv(report.sales.inStore[0])}`,
          `${formatCsv(report.sales.inStore[1])}`,
          `${formatCsv(report.sales.inStore[2])}`,
          `${formatCsv(report.sales.inStore[3])}`,
          `${formatCsv(report.sales.inStore[4])}`,
          `${formatCsv(report.sales.inStore[5])}`,
          `${formatCsv(report.sales.inStore[6])}`,
          ``,
          `${formatCsv(report.sales.inStoreTotal)}`,
          `${formatCsv(report.sales.inStorePercent, 'percent')}`
          // `${formatCsv(report.sales.inStorePerGuest)}`
        ],
        [
          'Delivery',
          `${formatCsv(report.sales.delivery[0])}`,
          `${formatCsv(report.sales.delivery[1])}`,
          `${formatCsv(report.sales.delivery[2])}`,
          `${formatCsv(report.sales.delivery[3])}`,
          `${formatCsv(report.sales.delivery[4])}`,
          `${formatCsv(report.sales.delivery[5])}`,
          `${formatCsv(report.sales.delivery[6])}`,
          '',
          `${formatCsv(report.sales.deliveryTotal)}`,
          `${formatCsv(report.sales.deliveryPercent, 'percent')}`
          // `${formatCsv(report.sales.deliveryPerGuest)}`
        ],
        [
          'Delivery Fees',
          `${formatCsv(report.sales.deliveryFees[0])}`,
          `${formatCsv(report.sales.deliveryFees[1])}`,
          `${formatCsv(report.sales.deliveryFees[2])}`,
          `${formatCsv(report.sales.deliveryFees[3])}`,
          `${formatCsv(report.sales.deliveryFees[4])}`,
          `${formatCsv(report.sales.deliveryFees[5])}`,
          `${formatCsv(report.sales.deliveryFees[6])}`,
          '',
          `${formatCsv(report.sales.deliveryFeesTotal)}`,
          `-`
          // `${formatCsv(report.sales.deliveryFeesPerGuest)}`
        ],
        [
          'Total',
          `${formatCsv(report.sales.totals[0])}`,
          `${formatCsv(report.sales.totals[1])}`,
          `${formatCsv(report.sales.totals[2])}`,
          `${formatCsv(report.sales.totals[3])}`,
          `${formatCsv(report.sales.totals[4])}`,
          `${formatCsv(report.sales.totals[5])}`,
          `${formatCsv(report.sales.totals[6])}`,
          '',
          `${formatCsv(report.sales.total)}`,
          `-`
          // `${formatCsv(report.sales.totalPerGuest)}`
        ],
        ['', '', '', '', '', '', '', '', '', '', ''],
        ['Payroll', '', '', '', '', '', '', '', '', '', ''],
        [
          'Management',
          `${formatCsv(report.payroll.management[0])}`,
          `${formatCsv(report.payroll.management[1])}`,
          `${formatCsv(report.payroll.management[2])}`,
          `${formatCsv(report.payroll.management[3])}`,
          `${formatCsv(report.payroll.management[4])}`,
          `${formatCsv(report.payroll.management[5])}`,
          `${formatCsv(report.payroll.management[6])}`,
          '',
          `${formatCsv(report.payroll.managementTotal)}`,
          `${formatCsv(report.payroll.managementPercent, 'percent')}`
          // `${formatCsv(report.payroll.managementPerGuest)}`
        ],
        [
          'Hourly Personnel',
          `${formatCsv(report.payroll.hourly[0])}`,
          `${formatCsv(report.payroll.hourly[1])}`,
          `${formatCsv(report.payroll.hourly[2])}`,
          `${formatCsv(report.payroll.hourly[3])}`,
          `${formatCsv(report.payroll.hourly[4])}`,
          `${formatCsv(report.payroll.hourly[5])}`,
          `${formatCsv(report.payroll.hourly[6])}`,
          '',
          `${formatCsv(report.payroll.hourlyTotal)}`,
          `${formatCsv(report.payroll.hourlyPercent, 'percent')}`
          // `${formatCsv(report.payroll.hourlyPerGuest)}`
        ],
        [
          `Taxes & Benefits`,
          `${formatCsv(report.payroll.taxes[0])}`,
          `${formatCsv(report.payroll.taxes[1])}`,
          `${formatCsv(report.payroll.taxes[2])}`,
          `${formatCsv(report.payroll.taxes[3])}`,
          `${formatCsv(report.payroll.taxes[4])}`,
          `${formatCsv(report.payroll.taxes[5])}`,
          `${formatCsv(report.payroll.taxes[6])}`,
          '',
          `${formatCsv(report.payroll.taxesTotal)}`,
          `${formatCsv(report.payroll.taxesPercent, 'percent')}`
          // `${formatCsv(report.payroll.taxesPerGuest)}`
        ],
        [
          'Total',
          `${formatCsv(report.payroll.totals[0])}`,
          `${formatCsv(report.payroll.totals[1])}`,
          `${formatCsv(report.payroll.totals[2])}`,
          `${formatCsv(report.payroll.totals[3])}`,
          `${formatCsv(report.payroll.totals[4])}`,
          `${formatCsv(report.payroll.totals[5])}`,
          `${formatCsv(report.payroll.totals[6])}`,
          '',
          `${formatCsv(report.payroll.total)}`,
          `${formatCsv(report.payroll.totalPercent, 'percent')}`
          // `${formatCsv(report.payroll.totalPerGuest)}`
        ],
        ['', '', '', '', '', '', '', '', '', '', ''],
        [
          'Cost of Goods',
          'Beginning Inventory',
          '',
          'Ending Inventory',
          '',
          'Difference',
          '',
          'Invoices',
          '',
          '',
          ''
          // ''
        ],
        [
          'Food',
          `${formatCsv(report.cogs.inventoryBeginningFood)}`,
          '-',
          `${formatCsv(report.cogs.inventoryEndingFood)}`,
          '=',
          `${formatCsv(report.cogs.inventoryDifferenceFood)}`,
          '+',
          `${formatCsv(report.cogs.invoicesFood)}`,
          '=',
          `${formatCsv(report.cogs.foodTotal)}`,
          `${formatCsv(report.cogs.foodPercent, 'percent')}`
          // `${formatCsv(report.cogs.foodPerGuest)}`
        ],
        [
          'Other',
          `${formatCsv(report.cogs.inventoryBeginningOther)}`,
          '-',
          `${formatCsv(report.cogs.inventoryEndingOther)}`,
          '=',
          `${formatCsv(report.cogs.inventoryDifferenceOther)}`,
          '+',
          `${formatCsv(report.cogs.invoicesOther)}`,
          '=',
          `${formatCsv(report.cogs.otherTotal)}`,
          `${formatCsv(report.cogs.otherPercent, 'percent')}`
          // `${formatCsv(report.cogs.otherPerGuest)}`
        ],
        [
          `Total`,
          `${formatCsv(report.cogs.inventoryBeginningTotal)}`,
          '-',
          `${formatCsv(report.cogs.inventoryEndingTotal)}`,
          '=',
          `${formatCsv(report.cogs.inventoryDifferenceTotal)}`,
          '+',
          `${formatCsv(report.cogs.invoicesTotal)}`,
          '=',
          `${formatCsv(report.cogs.total)}`,
          `${formatCsv(report.cogs.totalPercent, 'percent')}`
          // `${formatCsv(report.cogs.totalPerGuest)}`
        ],
        ['', '', '', '', '', '', '', '', '', '', ''],
        [
          'Prime Cost',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          `${formatCsv(report.primeCost)}`,
          `${formatCsv(report.primeCostPercent, 'percent')}`
          // `${formatCsv(report.primeCostPerGuest)}`
        ],
        [
          'Gross Margin',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          `${formatCsv(report.grossMargin)}`,
          `${formatCsv(report.grossMarginPercent, 'percent')}`
          // `${formatCsv(report.grossMarginPerGuest)}`
        ]
      ]

      let outputCsv = ''
      rows.forEach((row) => {
        outputCsv += '"' + row.join('","') + '"'
        outputCsv += '\n'
      })

      // let filename = 'report'
      // try {
      //   filename = `${Vue.mo ment(new Date(report.date.toDate()).toISOString())
      //     .subtract(1, 'week')
      //     .format('YYYYMMDD')}_${Vue.mom ent(
      //     new Date(report.date.toDate()).toISOString()
      //   )
      //     .subtract(1, 'day')
      //     .format('YYYYMMDD')}_report_${rootGetters['storeModule/name']}.csv`
      // } catch (e) {
      //   console.log(e)
      // }

      let fileStartDate =
        DateTime.fromSeconds(report.date.seconds)
          .setZone('America/New_York')
          .minus({ weeks: 1 })
          .toFormat('yyyyMMdd') || ''
      let fileEndDate =
        DateTime.fromSeconds(report.date.seconds)
          .setZone('America/New_York')
          .minus({ days: 1 })
          .toFormat('yyyyMMdd') || ''
      let fileType = 'report'
      let fileStore = rootGetters['storeModule/name']
      let filename = `${fileStartDate ? fileStartDate + '_' : ''}${
        fileEndDate ? fileEndDate + '_' : ''
      }${fileType}_${fileStore}.csv`

      return { filename, data: outputCsv }
    }
  },
  reportWeeklyTransfersCsvByReportId:
    (state, getters, rootState, rootGetters) => async (id) => {
      try {
        const report = getters.reportById(id)
        if (!report) {
          console.error('No report found for ID:', id)
          return null
        }

        // Get start and end dates from report
        // const startDate = DateTime.fromSeconds(report.date.seconds)
        //   .minus({ weeks: 1 })
        //   .startOf('day')
        // const endDate = DateTime.fromSeconds(report.date.seconds)
        //   .minus({ days: 1 })
        //   .endOf('day')

        const startDate = DateTime.now().startOf('day').minus({ weeks: 3 })
        const endDate = DateTime.now().endOf('day')

        const orderedTransfers =
          rootGetters['storeModule/transfers/transfersOrdered']
        const orderedWaste = rootGetters['storeModule/waste/wasteOrdered']

        if (!Array.isArray(orderedTransfers)) {
          console.error('No transfers array found')
          return null
        }

        console.log(
          `Processing ${orderedTransfers.length} transfers and ${orderedWaste.length} waste logs`
        )

        // First, let's define all possible fields for our transactions
        const headers = [
          'Date',
          'Transaction Type', // 'transfer' or 'waste'
          'Status', // 'requested', 'approved', 'completed', 'rejected', 'cancelled', etc.
          'Item Type', // 'recipe' or 'product'
          'Item Name',
          'Item ID',
          'Source Item ID', // For transfers with vendor product mapping
          'Destination Item ID', // For transfers with vendor product mapping
          'Quantity',
          'Unit Type',
          'Unit Cost',
          'Total Cost',
          'Source Store',
          'Source Store ID',
          'Destination Store',
          'Destination Store ID',
          'Reason', // For waste
          'Notes',
          'Created By',
          'Created At',
          'Requested By', // For transfers
          'Requested At', // For transfers
          'Approved By',
          'Approved At',
          'Completed By',
          'Completed At',
          'Cancelled By',
          'Cancelled At',
          'Updated By',
          'Updated At'
        ]

        // Helper function to safely convert Firestore timestamp to DateTime
        function safeFromSeconds(timestamp) {
          if (!timestamp || typeof timestamp.seconds !== 'number') {
            return DateTime.local()
          }
          return DateTime.fromSeconds(Number(timestamp.seconds))
        }

        // Process both transfers and waste
        const transactions = [...orderedTransfers, ...orderedWaste]
          .filter((txn) => {
            try {
              // Add logging to debug transaction type
              console.log('Transaction:', txn.id, 'Type:', txn.transactionType)
              return txn && txn.date && txn.date.seconds
            } catch (err) {
              console.error('Error filtering transaction:', txn && txn.id, err)
              return false
            }
          })
          .map((txn) => [
            // Basic Info
            safeFromSeconds(txn.date)
              .setZone('America/New_York')
              .toFormat('MM/dd/yyyy'),
            txn.transactionType || 'unknown', // Add default value for debugging
            txn.status || '',
            txn.itemType || '',
            txn.itemName || '',
            txn.itemId || '',
            txn.sourceItemId || '',
            txn.destinationItemId || '',

            // Quantities and Costs
            txn.quantity || 0,
            txn.unitType || '',
            txn.unitCost || 0,
            txn.totalCost || 0,

            // Store Information
            txn.sourceStoreName || '',
            txn.sourceStoreId || '',
            txn.destinationStoreName || '',
            txn.destinationStoreId || '',

            // Details
            txn.reason || '', // Waste reason
            txn.notes || '',

            // Audit Trail - Users
            txn.createdBy || '',
            safeFromSeconds(txn.createdAt)
              .setZone('America/New_York')
              .toFormat('MM/dd/yyyy HH:mm'),
            txn.requestedBy || '',
            txn.requestedAt
              ? safeFromSeconds(txn.requestedAt).toFormat('MM/dd/yyyy HH:mm')
              : '',
            txn.approvedBy || '',
            txn.approvedAt
              ? safeFromSeconds(txn.approvedAt).toFormat('MM/dd/yyyy HH:mm')
              : '',
            txn.completedBy || '',
            txn.completedAt
              ? safeFromSeconds(txn.completedAt).toFormat('MM/dd/yyyy HH:mm')
              : '',
            txn.cancelledBy || '',
            txn.cancelledAt
              ? safeFromSeconds(txn.cancelledAt).toFormat('MM/dd/yyyy HH:mm')
              : '',
            txn.updatedBy || '',
            txn.updatedAt
              ? safeFromSeconds(txn.updatedAt).toFormat('MM/dd/yyyy HH:mm')
              : ''
          ])

        // Only proceed if we have data to export
        if (transactions.length === 0) {
          console.warn('No valid transfer or waste data to export')
          return null
        }

        // Combine all rows
        const rows = [headers, ...transactions]

        let outputCsv = ''
        rows.forEach((row) => {
          outputCsv += '"' + row.join('","') + '"'
          outputCsv += '\n'
        })

        // Generate filename
        let fileStartDate = startDate.toFormat('yyyyMMdd') || ''
        let fileEndDate = endDate.toFormat('yyyyMMdd') || ''
        let fileType = 'transactions'
        let fileStore = rootGetters['storeModule/name']
        let filename = `${fileStartDate ? fileStartDate + '_' : ''}${
          fileEndDate ? fileEndDate + '_' : ''
        }${fileType}_${fileStore}.csv`

        return { filename, data: outputCsv }
      } catch (error) {
        console.error('Error generating transfers CSV:', error)
        return null
      }
    },
  reportWeeklyInvoicesCsvByReportId(state, getters, rootState, rootGetters) {
    return async (reportId) => {
      if (!getters['reports'][reportId])
        throw new Error(
          'Invalid ReportID: ',
          reportId ? reportId : 'No ID Provided'
        )

      let report = getters['reports'][reportId]
      console.log(report)
      let invoices = await rootGetters['storeModule/reportWeeklyInvoices'](
        new Date(report.date.toDate()).toISOString()
      )
      console.log('invoices: ', invoices)

      let rows = [
        [
          'Bill No',
          `Vendor`,
          `Bill Date`,
          `Terms`,
          `Expense Account`,
          `Expense Line Amount`,
          `Scan`
        ]
      ]

      invoices.invoices.forEach((invoice) => {
        if (Object.prototype.hasOwnProperty.call(invoice, 'categories')) {
          Object.entries(invoice.categories).forEach(([key, value]) => {
            rows.push([
              invoice.billNumber,
              invoice.vendor,
              invoice.billDate,
              invoice.terms,
              key,
              value,
              invoice.downloadURL || ''
              // ? `=HYPERLINK(""${invoice.downloadURL}"";""Download"")`
              // : ''
            ])
          })
        } else {
          rows.push([
            invoice.billNumber,
            invoice.vendor,
            invoice.billDate,
            invoice.terms,
            invoice.expenseAccount,
            invoice.lineAmount,
            invoice.downloadURL || ''
            // ? `=HYPERLINK(""${invoice.downloadURL}"";""Download"")`
            // : ''
          ])
        }
      })

      console.log(rows)

      let outputCsv = ''
      rows.forEach((row) => {
        outputCsv += '"' + row.join('","') + '"'
        outputCsv += '\n'
      })

      let fileStartDate =
        DateTime.fromSeconds(report.date.seconds)
          .setZone('America/New_York')
          .minus({ weeks: 1 })
          .toFormat('yyyyMMdd') || ''
      let fileEndDate =
        DateTime.fromSeconds(report.date.seconds)
          .setZone('America/New_York')
          .minus({ days: 1 })
          .toFormat('yyyyMMdd') || ''
      let fileType = 'invoices'
      let fileStore = rootGetters['storeModule/name']
      let filename = `${fileStartDate ? fileStartDate + '_' : ''}${
        fileEndDate ? fileEndDate + '_' : ''
      }${fileType}_${fileStore}.csv`

      return { filename, data: outputCsv }
    }
  },
  reportPreviousMonthInvoicesCsv(state, getters, rootState, rootGetters) {
    return async () => {
      // Get first and last day of previous month
      const now = DateTime.now()
      console.log('now: ', now)
      const firstDayPrevMonth = now.startOf('month').minus({ months: 1 })
      console.log('firstDayPrevMonth: ', firstDayPrevMonth)
      const lastDayPrevMonth = now.startOf('month').minus({ days: 1 })
      console.log('lastDayPrevMonth: ', lastDayPrevMonth)

      // Format date as YYYY-MM-DD for the first day of the month
      const formattedDate = lastDayPrevMonth.toFormat('yyyy-MM-dd')

      // Calculate number of days between first and last day
      const numberOfDays = lastDayPrevMonth.daysInMonth - 1

      console.log('Number of days:', numberOfDays)
      console.log('Formatted date:', formattedDate)

      // Call reportDateRangeInvoicesCsv with the date range
      return await getters.reportDateRangeInvoicesCsv({
        date: formattedDate,
        numberOfDays
      })
    }
  },
  reportDateRangeInvoicesCsv(state, getters, rootState, rootGetters) {
    // Use in console to download CSV:
    //
    let downloadCsv = function ({ filename = null, data = null }) {
      if (!filename || !data) return
      var hiddenElement = document.createElement('a')
      // critical to use encodeURIComponent instead of just encodeURI for # signs
      hiddenElement.href =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
      hiddenElement.target = '_blank'
      hiddenElement.download = `${filename}.csv`
      hiddenElement.click()
      hiddenElement.remove()
    }
    //
    // Then run: __VUE_DEVTOOLS_GLOBAL_HOOK__.store.getters['storeModule/reports/reportDateRangeInvoicesCsv']({date: "2025-01-01", numberOfDays: 46}).then(file => downloadCsv(file))
    //
    return async ({ date, numberOfDays }) => {
      // if (!date)
      //   throw new Error(
      //     'Invalid Date: ',
      //     date ? date : 'No Date Provided'
      //   )

      let invoices = await rootGetters['storeModule/reportDateRangeInvoices']({
        date,
        numberOfDays
      })
      console.log('invoices: ', invoices)

      const fallback = (value, defaultValue) =>
        value != null ? value : defaultValue

      let rows = [
        [
          'Invoice Date',
          'Cleaned Item Name',
          'Item Name',
          'Item Unit Cost',
          'Item Amount Billed',
          'Item Total Cost',
          'Location',

          'Invoice No',
          'Vendor Name',
          'Vendor Terms',
          'Vendor Expense Account',
          'Invoice Total Cost',
          'Invoice Fees',
          'Invoice Tax',
          'Invoice Cancelled',
          'Invoice Completed',
          'Invoice Status',
          // 'Date',
          'Order Created At',
          'Order Date',
          'Invoice Completed At',
          'Order UID',
          'Invoice Delivery Date',
          'Item Product UID',

          'Item Action',
          'Item Amount Entered',
          'Item Amount Ordered',
          'Item Previous Cost',
          'Invoice Previous Cost Total',
          'Item Amount Received',
          'Item Amount Returned',
          'Item Return Reason'
          // 'Invoice Adjustment Cost Total',
        ]
      ]

      invoices.invoices.forEach((invoice) => {
        if (invoice.lineItems) {
          Object.values(invoice.lineItems).forEach((item) => {
            // if (item.action !== 'Received') return
            rows.push([
              fallback(invoice.billDate, ''),
              '',
              fallback(item.name, ''),
              fallback(item.cost, ''),
              fallback(item.amountBilled, ''),
              fallback(item.totalCost, ''),
              rootGetters['storeModule/name'],

              fallback(invoice.billNumber, ''),
              fallback(invoice.vendorName, ''),
              fallback(invoice.terms, ''),
              fallback(invoice.expenseAccount, ''),
              fallback(invoice.totalCost, ''),
              fallback(invoice.fees, ''),
              fallback(invoice.tax, ''),
              fallback(invoice.cancelled, ''),
              fallback(invoice.completed, ''),
              fallback(invoice.status, ''),
              // fallback(invoice.date, ''),
              fallback(invoice.createdAt, ''),
              fallback(invoice.orderDate, ''),
              fallback(invoice.completedAt, ''),
              fallback(invoice.orderId, ''),
              fallback(invoice.deliveryDate, ''),
              fallback(item.id, ''),
              fallback(item.action, ''),
              fallback(item.amountEntered, ''),
              fallback(item.amountOrdered, ''),
              fallback(item.previousCost, ''),
              fallback(
                invoice.previousCostTotal
                  ? invoice.previousCostTotal.toFixed(2)
                  : '',
                ''
              ),
              fallback(item.amountReceived, ''),
              fallback(item.amountReturned, ''),
              fallback(item.returnReason, '')
              // fallback(invoice.adjustmentCostTotal, ''),
            ])
          })
        }
      })

      console.log(rows)

      let outputCsv = ''
      rows.forEach((row) => {
        outputCsv += '"' + row.join('","') + '"'
        outputCsv += '\n'
      })

      let fileStartDate =
        DateTime.fromISO(date)
          .setZone('America/New_York')
          .minus({ days: numberOfDays || 7 })
          .toFormat('yyyyMMdd') || ''
      let fileEndDate =
        DateTime.fromISO(date)
          .setZone('America/New_York')
          .minus({ days: 1 })
          .toFormat('yyyyMMdd') || ''
      let fileType = 'invoices'
      let fileStore = rootGetters['storeModule/name']
      let filename = `${fileStartDate ? fileStartDate + '_' : ''}${
        fileEndDate ? fileEndDate + '_' : ''
      }${fileType}_${fileStore}.csv`

      downloadCsv({ filename, data: outputCsv })

      return { filename, data: outputCsv }
    }
  }
}

const actions = {
  bindStore: firestoreAction(
    ({ bindFirestoreRef, commit, state }, { storeId }) => {
      commit(
        'setRef',
        db.collection('stores').doc(storeId).collection('reports')
      )
      return bindFirestoreRef(
        'data',
        state.ref
          .where('status', 'in', ['saved', 'open'])
          .where('date', '>=', DateTime.now().minus({ days: 150 }).toJSDate())
      )
    }
  ),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function ({ getters }, payload) {
    let id = newId()
    let data = {
      createdAt: Timestamp.now(),
      status: 'open',
      id,
      ...payload
    }
    console.log('reports/create', id, data)
    return await getters.ref
      .doc(id)
      .set(data)
      .then(() => id)
      .catch((err) => err)
  },
  delete: async function ({ dispatch }, id) {
    console.log('reports/delete', id)
    if (!id) throw new Error('No ID provided.')
    return dispatch('updateItem', { id, data: { status: 'deleted' } })
  },
  fixStatus({ getters, dispatch }) {
    return Object.values(getters['reports']).forEach((i) => {
      if (!Object.prototype.hasOwnProperty.call(i, 'status'))
        dispatch('updateItem', { id: i.id, data: { status: 'open' } })
    })
  },
  updateItem({ getters, rootGetters }, { id, data }) {
    console.log('reports/updateItem', id, data)
    return getters.ref.doc(id).update({
      ...data,
      lastUpdatedAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      updatedBy: rootGetters['user/id']
    })
  },
  async gatherAPI({ rootGetters }, { date }) {
    let storeName = rootGetters['storeModule/name']
    if (window.location.hostname === '127.0.0.1') {
      return await axios.get(
        `http://127.0.0.1:5001/seoulspiceapp/us-central1/fetchWeek?date=${date}&location=${storeName}&version=3`
      )
    } else {
      return await axios.get(
        `https://us-central1-seoulspiceapp.cloudfunctions.net/fetchWeek?date=${date}&location=${storeName}&version=3`
      )
    }
  },
  // create: async function({ getters }, payload) {
  //   let id = newId()
  //   let data = {
  //     ...payload,
  //     date: Timestamp.now(),
  //     createdAt: Timestamp.now(),
  //     status: 'open',
  //     completed: false,
  //     tax: 0,
  //     fees: 0,
  //     totalCost: 0,
  //     invoiceNumber: null,
  //     completedAt: null,
  //     completedBy: null,
  //     id
  //   }
  //   console.log('invoices/create', id, data)
  //   return getters.ref
  //     .doc(id)
  //     .set(data, { merge: true })
  //     .then(() => {
  //       return id
  //     })
  //     .catch(err => {
  //       return err
  //     })
  // },
  // updateItem({ getters }, { id, data }) {
  //   console.log('invoices/updateItem', id, data)
  //   return getters.ref.doc(id).update(data)
  // },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const reports = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}

export default reports

// invoiceId: {
//   vendor: {
//     vendorId,
//     vendorName,
//     contactName

//     storeAccount
//     storeAddress

//     orderDate
//     deliveryDate
//   },

//   completedAt:
//   completedBy:
//   status:

//   productId: {
//     // productId
//     // orderCode
//     // name

//     // amountEntered
//     // amountOrdered

//     // inputType?
//     // par
//     // order unit (50 rolls)
//     // qty per order unit

//     // c ostTotal (each/total?) (costEach = amoundOrdered - returnQty / total)
//     // invoiceAction
//     // returnReason
//     // returnQty
//   }
// }
